import { CartItemImage } from "./CartItemImage";
import { CartItemDetails } from "./CartItemDetails";
import { CartItemPrice } from "./CartItemPrice";
import { CartItemQuantityControls } from "./CartItemQuantityControls";
import { Spinner } from '../ui/Spinner';

interface CartItemProps {
  item: {
    id: string;
    productId: string;
    name: string;
    subtitle: string;
    price: number;
    mrpPrice?: number;
    quantity: number;
    image: string;
    size?: string;
    color?: string;
    productVariantId: string;
  };
  onQuantityChange: (itemId: string, quantity: number) => void;
  onRemove: (itemId: string) => void;
  updating?: boolean;
}

export const CartItem = ({ item, onQuantityChange, onRemove, updating = false }: CartItemProps) => {
  const handleQuantityChange = (change: number) => {
    const newQuantity = item.quantity + change;
    if (newQuantity >= 1) {
      onQuantityChange(item.id, newQuantity);
    }
  };

  const handleRemove = () => {
    onRemove(item.id);
  };

  return (
    <div className="flex gap-4 p-4 bg-white rounded-lg border border-gray-100 shadow-sm">
      {/* Product Image */}
      <CartItemImage image={item.image} name={item.name} />
      {/* Product Details and Controls */}
      <div className="flex-1 space-y-3">
        <CartItemDetails
          name={item.name}
          subtitle={item.subtitle}
          size={item.size}
          color={item.color}
          onRemove={handleRemove}
        />
        <div className="flex items-center justify-between">
          <CartItemPrice price={item.price} mrpPrice={item.mrpPrice} />
          <CartItemQuantityControls
            quantity={item.quantity}
            onQuantityChange={handleQuantityChange}
            disabled={updating}
          />
          {updating && (
            <span className="flex items-center ml-2 w-auto">
              <Spinner className="w-[10px] h-[10px]" />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};